import { loadFullLine } from '@/stores/load/loadFullLine'
import { useLoad } from './useLoad'

export function useLoadFullLine(
	line: string,
	{ level = 0 }: { level?: number } = {},
) {
	return useLoad(loadFullLine, { level, line })
}
